function showToast(message, type = "info", duration = 3000) {
  const toastContainer = document.getElementById("toast-container");

  // Create the toast element
  const toast = document.createElement("div");
  toast.className = `toast ${type}`;
  toast.textContent = message;

  // Append the toast to the container
  toastContainer.appendChild(toast);

  // Show the toast
  setTimeout(() => {
    toast.classList.add("show");
  }, 100);

  // Remove the toast after the duration
  setTimeout(() => {
    toast.classList.remove("show");
    setTimeout(() => toast.remove(), 300); // Wait for fade-out animation
  }, duration);
}

// Usage examples
// showToast("Product added to wishlist.", "success");
// showToast("Failed to remove product.", "error");
// showToast("You have new notifications.", "info");
// showToast("Check your input.", "warning");

(function (Wishlist) {
  const wishlistButton = document.querySelectorAll(".wishlist-btn");
  const addcartButton = document.querySelectorAll(".is-add-cart");
  const wishlistTile = document.querySelectorAll(".wishlist-container");
  const wishCounts = document.querySelectorAll(".js-wish-count");
  let numProductTiles = wishlistTile.length;
  let wishlist = JSON.parse(localStorage.getItem("user_wishlist") || "[]");

  console.log("🧞‍♂️ wishlist: ", wishlist);

  function updateWishlistCount(count) {
    if (wishCounts.length === 0) return;

    wishCounts.forEach((wishCount) => {
      wishCount.classList.add("counting");
      wishCount.textContent = count;

      const label =
        count === 0
          ? window.Themei18n.wishlist.none
          : count === 1
            ? window.Themei18n.wishlist.one
            : window.Themei18n.wishlist.other;
      wishCount.setAttribute("aria-label", label.replace("[count]", count));

      if (count === 0) {
        wishCount.classList.add("hidden");
      }
    });
  }

  updateWishlistCount(wishlist.length);

  /*
   * Update button to show current state (gold for active)
   */
  const animateWishlist = (element) => {
    element.classList.toggle("is-added");
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   */
  const updateWishlist = (element) => {
    const productHandle = element.getAttribute("data-product-handle");
    const productId = element.getAttribute("data-product-id");
    const isRemove = element.classList.contains("is-added");
    const isAddCart = element.classList.contains("is-add-cart");

    if (isRemove) {
      const removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      showToast("Product removed from wishlist.", "info");
      const tbody = element.closest("tbody");
      if (tbody) {
        tbody.style.transition = "line-height 1.5s";
        tbody.style.lineHeight = "0";
        setTimeout(() => tbody.remove(), 1500);
      }
    } else if (isAddCart) {
      cart.add(productId);
      const removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      const tbody = element.closest("tbody");
      if (tbody) {
        tbody.style.transition = "line-height 1.5s";
        tbody.style.lineHeight = "0";
        setTimeout(() => tbody.remove(), 1500);
      }
    } else {
      wishlist.push(productHandle);
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      showToast("Product added to wishlist.", "success");
    }

    updateWishlistCount(wishlist.length);

    const wishlistTotal = document.querySelector("#wishlist-total span");
    if (wishlistTotal) wishlistTotal.innerHTML = wishlist.length;
  };

  /*
   * Activate buttons for items already in the wishlist
   */
  const activateItemsInWishlist = () => {
    wishlistButton.forEach((button) => {
      const productHandle = button.getAttribute("data-product-handle");
      if (wishlist.includes(productHandle)) {
        button.classList.add("is-added");
      }
    });
  };

  /*
   * Display only wishlist items
   */
  const displayOnlyWishlistItems = () => {
    wishlistTile.forEach((tile) => {
      const productHandle = tile.getAttribute("data-product-handle");
      if (!wishlist.includes(productHandle)) {
        tile.remove();
        numProductTiles--;
      }
    });
  };

  /*
   * Load wishlist on wishlist page
   */
  const loadWishlist = () => {
    if (!window.location.href.includes("pages/wishlist")) return;

    displayOnlyWishlistItems();
    const loader = document.querySelector(".wishlist-loader");
    const wishlistGrid = document.querySelector(".js-wishlist");
    if (loader) {
      loader.classList.add("opacity-0");

      setTimeout(() => {
        loader.remove();

        wishlistGrid.classList.remove("hidden");

        document.querySelectorAll(".wishlist-product").forEach((product) => {
          product.style.display = "block";
        });

        if (numProductTiles === 0) {
          document.querySelector(".wishlist-empty")?.classList.remove("hidden");
          document.querySelector(".wishlist-empty")?.classList.add("flex");
          document.querySelector(".wishlist-head")?.classList.add("hidden");
        } else {
          document.querySelector(".wishlist-empty")?.classList.add("hidden");
        }
      }, 2000);
    }
  };

  /*
   * Bind UI actions
   */
  const bindUIActions = () => {
    wishlistButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        updateWishlist(button);
        animateWishlist(button);
      });
    });

    addcartButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        updateWishlist(button);
        animateWishlist(button);
      });
    });
  };

  Wishlist.init = () => {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
  };
})(window.Wishlist || (window.Wishlist = {}));
